import { Component, inject, OnInit } from '@angular/core';
import { ParametersService } from '@app/components/parameters/parameters.service';
import { UserManagerService } from '@app/managers';
import { CountryService } from '@app/services';
import { AuthService } from '@auth0/auth0-angular';
import { first, switchMap } from 'rxjs';

@Component({
    imports: [],
    templateUrl: './login-callback.component.html'
})
export class LoginCallbackComponent implements OnInit {

    private readonly authService = inject(AuthService);
    private readonly userManagerService = inject(UserManagerService);
    private readonly parametersService = inject(ParametersService);
    private readonly countryService = inject(CountryService);
    ngOnInit(): void {
        this.authService.isAuthenticated$.subscribe(isAuthed => {
            if (isAuthed) {
                this.userManagerService.getUser()
                    .pipe(
                        first(user => !!user?.locale),
                        switchMap(user => this.countryService.getLocaleByCode(user?.locale)))
                    .subscribe({
                        next: (locale) => {
                            this.parametersService.setCountry(locale);
                        }
                    });
            }
        });
    }
}
